// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ySI0","largestCol":"styles_largestCol__W9azw","smallestCol":"styles_smallestCol__26pb1"};